import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Fade } from "@mui/material";

import CustomTableV2 from "../../common/CustomTableV2";

import { GetIndiChallengeParticipants } from "../../redux/indiChallenge/actions";

import "./style.css";
import moment from "moment";

function IndiChallengeParticipant(props) {
    const statusLabel = ["INACTIVE", "ACTIVE", "COMPLETED", "EXPIRED"];

    let today = new Date();

    return (
        <div className="main-container" id="indi-challenge-participants">
            <Fade in={true}>
                <div>
                    <CustomTableV2
                        title="INDI CHALLENGE PARTICIPANTS"
                        description=""
                        store={props.IndiChallenge?.participants}
                        table={{
                            headers: [
                                { title: "#" },
                                { title: "User" },
                                { title: "Challenge" },
                                { title: "Duration" },
                                { title: "Started" },
                                { title: "Completed" },
                                { title: "Status" },
                            ],
                            body: (icp, i) => {
                                let status = icp?.status;

                                if (!icp?.completionDate && today > new Date(icp?.challenge_enddate)) {
                                    status = 3;
                                }

                                return (
                                    <tr className={i % 2 == 0 ? "tr-even" : ""}>
                                        <td><h5>{i}</h5></td>
                                        <td><h5>{(icp?.first_name + " " + icp?.last_name)?.toUpperCase()}</h5></td>
                                        <td><h5>{icp?.challenge_title?.toUpperCase()}</h5></td>
                                        <td><h5>{moment(icp?.challenge_startdate).format("YYYY-MM-DD")} - {moment(icp?.challenge_enddate).format("YYYY-MM-DD")}</h5></td>
                                        <td><h5>{icp?.startDate ? moment(icp?.startDate).format("YYYY-MM-DD") : "-"}</h5></td>
                                        <td><h5>{icp?.completionDate ? moment(icp?.completionDate).format("YYYY-MM-DD") : "-"}</h5></td>
                                        <td><h5>{statusLabel[status]}</h5></td>
                                    </tr>
                                )
                            }
                        }}

                        actions={{
                            get: (page, count, filter, sort) => {
                                props.GetIndiChallengeParticipants(page, count, filter, sort);
                            },
                        }}
                    />
                </div>
            </Fade>

        </div>
    );
}

const mapStateToProps = (state) => ({
    IndiChallenge: state.IndiChallenge,
})

export default connect(mapStateToProps, {
    GetIndiChallengeParticipants,
})(IndiChallengeParticipant);
